/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskRubricOutput } from './taskRubricOutput';

export type TaskRubric = TaskRubricOutput | null;
